import * as AT from "./actionTypes";
import * as MT from "./mutationTypes";

export default {
  [AT.SNACKBAR]: (context, data) => {
    context.commit(MT.SET_SNACKBAR, {
      status: true,
      ...data
    });
  },
  [AT.GET_USER]: context => {
    context.commit(MT.GET_USER);
  }
};
